import type { AdvisingAndCoachingInDB, ListAdvisingAndCoachingResponse } from "@profile-service-types/index.ts";
import type { UseQueryOptions } from "@tanstack/vue-query";
import { useQuery } from "@tanstack/vue-query";
import type { List } from "lodash";
import type { Ref } from "vue";
import { computed, unref } from "vue";
import { profileServiceRequest } from "@/services/utils";

interface Args<TData = AdvisingAndCoachingInDB[]> {
  participant_okta_ids: Ref<List<string>> | List<string>;
  useQueryOptions?: Partial<UseQueryOptions<AdvisingAndCoachingInDB[], Error, TData>>;
}

export const getQueryKey = (id: Ref<List<string>> | List<string>) => ["fetchGetAdvisingAndCoaching", id];

export const useGetAdvisingAndCoaching = <TData = AdvisingAndCoachingInDB[]>({
  participant_okta_ids,
  useQueryOptions,
}: Args<TData>) => {
  const fetchGetAdvisingAndCoaching = (): Promise<ListAdvisingAndCoachingResponse["data"]> =>
    profileServiceRequest({
      method: "get",
      url: `/profiles/advising_and_coaching/`,
      params: { participant_okta_ids: unref(participant_okta_ids) ?? "" },
    }).then((val: { data: ListAdvisingAndCoachingResponse }) => val?.data?.data);

  return useQuery<AdvisingAndCoachingInDB[], Error, TData>({
    queryKey: computed(() => getQueryKey(participant_okta_ids)),
    queryFn: fetchGetAdvisingAndCoaching,
    ...useQueryOptions,
  });
};
